import CardDController from "./CardDController";

export default CardDController;
